// import external dependencies
import $ from 'jquery';

// [BRYAN] Altri import
import 'datatables/media/js/jquery.dataTables.min';
import 'jquery-ui-dist/jquery-ui.min';
import 'slick-carousel';
import Sticky from 'sticky-js';
import 'jssocials';
import '@fancyapps/fancybox';
import 'select2';
// import Swiper from 'swiper/dist/js/swiper.min'; Disabilitato - Se abilitato dice che non è mai utilizzato

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_pages.js';

// import local dependencies
import Router from './util/Router';
import './util/animate';
import './util/homeCurrency';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
 
import './components/_swiper.js'; import './components/headerBanner.js'; import './components/map'; import './components/map.js'; import './components/map/infobox.js'; import './components/map/markerclusterer.js'; import './components/search.js';
 
/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

window.Sticky = Sticky;

// Load Events
$(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js